import { useMutation } from '@tanstack/react-query';
import { sendSharedProfileOtp } from '../api/shared-profile.api';

/** Send (or resend) the recipient's view-verification code (MYN-58). */
export function useSendSharedProfileOtp(token: string) {
  return useMutation({ mutationFn: () => sendSharedProfileOtp(token) });
}
